import { ReactNode } from "react";
// mui
import { Box, IconButton, Icon, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// assets
import bottom_circles from "src/components/UI/Shared/assets/images/bottom-circles.png";
import contact_icon from "src/components/UI/Shared/assets/images/contact-us.png";
import styles from "src/components/UI/Shared/assets/scss/BasePanel.module.scss";

interface BasePanelProps {
  openModal: boolean;
  onClose: (event: React.SyntheticEvent | Event, reason?: string) => void;
  panelName: string;
  minH?: string;
  ml?: string;
  mt?: string;
  children: ReactNode;
}
const BasePanel = ({
  openModal,
  onClose,
  panelName,
  minH,
  ml,
  mt,
  children,
}: BasePanelProps) => {
  return (
    <Box className={`${openModal ? styles.box : styles.hidden} `}>
      <div className={styles.header}>
        <div className={styles.closeDiv}>
          <IconButton className={styles.closeIcon} onClick={onClose}>
            <Icon className={`${styles.iconRoot}`}>
              <CloseIcon
                sx={{
                  fontSize: "1.25rem",
                  color: "#ecf8ff",
                  fontWeight: "900",
                }}
              />
            </Icon>
          </IconButton>
        </div>
        <div>
          <Typography className={styles.headerText} variant="h5" component="h5">
            {panelName}
          </Typography>
        </div>
      </div>
      <div
        className={styles.content}
        style={{
          marginLeft: ml ? ml : "15px",
          marginTop: mt ? mt : "0",
          minHeight: minH ? minH : "70%",
        }}
      >
        {children}
      </div>
      <div className={styles.footer}>
        <div
          className={styles.copyRightsDiv}
          // onClick={() => navigate("/contact-us")}
          onClick={() => (window.location.href = "/#contact")}
        >
          <div className={styles.circularDiv}>
            <Icon
              className={`${styles.iconRoot}`}
              style={{ width: "2.75rem", height: "2.7rem" }}
            >
              <img
                src={contact_icon}
                style={{ width: "2.75rem", height: "2.7rem" }}
              />
            </Icon>
          </div>
          <p>© Copyright 2022. All Rights Reserved. GiSimplify</p>
        </div>
        <div className={styles.bottomCirles}>
          <img src={bottom_circles} alt="Bottom circles" />
        </div>
      </div>
    </Box>
  );
};

export default BasePanel;
